import gql from 'graphql-tag';

export const serverInfoQuery = gql`{
        information {
          key
          value
        }
      }`;

export const updateMyUserLanguage = gql`
  mutation updateMyUser($preferredLanguage: String!) {
    updateMyUser(preferredLanguage: $preferredLanguage) {
      preferredLanguage
    }
  }
`;

export const updateMyUserPreferredLipids = gql`
  mutation updateMyUser($preferredLipidsUnit: String!) {
    updateMyUser(preferredLipidsUnit: $preferredLipidsUnit) {
      preferredLipidsUnit
    }
  }
`;

export const updateMyUserPreferredGlucose = gql`
  mutation updateMyUser($preferredGlucoseUnit: String!) {
    updateMyUser(preferredGlucoseUnit: $preferredGlucoseUnit) {
      preferredGlucoseUnit
    }
  }
`;

